import { create } from 'zustand'
import { Transaction } from '~pages/CardsPage/Cards/Transactions/types'

export interface Data {
    tx?: Transaction
    isOpen: boolean
}

interface SendState {
    data: Data
    setData: (data: Data) => void
}

export const useCardDetailsStore = create<SendState>(set => ({
    data: {
        tx: undefined,
        isOpen: false,
    },
    setData: (data: Data) => {
        set(prev => {
            return { ...prev, data }
        })
    },
}))
